import { useMemo } from 'react'
import Chart from 'react-apexcharts'

function CostChart({ data, forecast = [], title = 'Coûts au fil du temps' }) {
  const options = useMemo(() => ({
    chart: {
      id: 'cost-chart',
      type: 'area',
      toolbar: {
        show: true,
        tools: {
          download: true,
          zoom: true,
          pan: true,
          reset: true,
        },
      },
      zoom: {
        enabled: true,
      },
    },
    title: {
      text: title,
      align: 'left',
      style: {
        fontSize: '16px',
        fontWeight: 600,
      },
    },
    xaxis: {
      type: 'datetime',
      labels: {
        datetimeFormatter: {
          day: 'dd MMM',
        },
      },
    },
    yaxis: {
      title: {
        text: 'Coût (USD)',
      },
      min: 0,
      labels: {
        formatter: (value) => `$${value.toFixed(2)}`,
      },
    },
    stroke: {
      curve: 'smooth',
      width: 2,
      dashArray: [0, 5], // Solid for actual, dashed for forecast
    },
    fill: {
      type: ['gradient', 'gradient'],
      gradient: {
        shadeIntensity: 0.3,
        opacityFrom: 0.7,
        opacityTo: 0.2,
        stops: [0, 90, 100],
      },
    },
    markers: {
      size: 4,
      hover: {
        size: 6,
      },
    },
    tooltip: {
      x: {
        format: 'dd MMM yyyy',
      },
      y: {
        formatter: (value) => `$${value.toFixed(4)}`,
      },
    },
    colors: ['#0d6efd', '#ffc107'],
    legend: {
      position: 'top',
      horizontalAlign: 'right',
    },
    grid: {
      borderColor: '#e7e7e7',
      strokeDashArray: 4,
    },
    annotations: forecast.length > 0 ? {
      xaxis: [{
        x: forecast[0]?.date ? new Date(forecast[0].date).getTime() : new Date().getTime(),
        borderColor: '#ffc107',
        label: {
          text: 'Prévision',
          style: {
            color: '#fff',
            background: '#ffc107',
          },
        },
      }],
    } : {},
    noData: {
      text: 'Aucune donnée disponible',
      align: 'center',
      verticalAlign: 'middle',
    },
  }), [title, forecast])

  const series = useMemo(() => {
    const seriesData = []

    // Historical data
    if (data && data.length > 0) {
      seriesData.push({
        name: 'Coûts réels',
        data: data.map(item => ({
          x: new Date(item.date).getTime(),
          y: item.cost || item.value || 0,
        })),
      })
    }

    // Forecast data
    if (forecast && forecast.length > 0) {
      seriesData.push({
        name: 'Prévision',
        data: forecast.map(item => ({
          x: new Date(item.date).getTime(),
          y: item.cost || item.value || 0,
        })),
      })
    }

    return seriesData
  }, [data, forecast])

  return (
    <div className="cost-chart">
      <Chart
        options={options}
        series={series}
        type="area"
        height={350}
      />
    </div>
  )
}

export default CostChart
